<template>
  <div
    class="overlay"
    :class="[isShow ? showClass : hideClass]"
    id="popup-return"
    
  >
    <div class="popup" :style="`width:${width}px`">
      <div class="popup-body">
        <div class="popup-status">
          <p class="popup-status-text newline">{{ message }}</p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              ref="refYesBtn"
              @click="confirm"
              :disabled="isOkDisabled"
            >
              {{ confirmText }}
            </button>
            <button class="frm-btn large" @click="cancel" @blur="onblur" v-if="cancelText != ''">
              {{ cancelText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "ConfirmDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "450",
    },
    confirmText: {
      type: String,
      default: "はい",
    },
    cancelText: {
      type: String,
      default: "いいえ",
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      isOkDisabled: false,
    };
  },
  computed: {},
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
      this.handleBodyScrollOnModalStateChange(newVal)
    },
  },
  methods: {
    ...mapMutations("businessModule", ["handleBodyScrollOnModalStateChange"]),
    onblur(e){
      if(!e) return;
      e.preventDefault();
      this.$refs.refYesBtn.focus();
    },
    // **********************************************
    // * confirmダイアログではいが選択された時の処理
    // **********************************************
    confirm() {
      this.$emit("confirm");
    },
    // **********************************************
    // * confirmダイアログでいいえが選択された時の処理
    // **********************************************
    cancel() {
      this.$emit("cancel");
    },
    initFocus(){
      this.$refs.refYesBtn.focus();
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  .popup>.popup-body>.frm-btn-row>.frm-item {
    flex-wrap: wrap;
    gap: 10px;
  }
  .frm-btn+.frm-btn {
    margin-left: 0px;
  }
}
</style>